export default "__VITE_ASSET__bhfNnGou__"